import { useTranslation } from "src/hooks";
import { Iprefix, ItranslateObj } from "src/hooks/useTranslation";

function useTabTranslation<F extends Iprefix>({
  featurePrefix,
  tabPrefix,
}: {
  featurePrefix: F;
  tabPrefix: keyof ItranslateObj[F];
}) {
  const { translate, t, ...rest } = useTranslation(featurePrefix);

  const tabTranslate = (key: string, options?: any) => {
    if (typeof tabPrefix !== "string") {
      return translate(`${featurePrefix}.${key}`, options);
    }

    return translate(`${featurePrefix}.${tabPrefix}.${key}`, options);
  };

  return {
    t: tabTranslate,
    translate,
    ...rest,
  };
}

export default useTabTranslation;
